"use strict";
exports.__esModule = true;
exports.getOfferFees = void 0;
var pricing_offer_1 = require("../pricing-offer");
var calculate_installments_1 = require("./calculate-installments");
var getOfferFees = function (offer, paymentMethodType, pricingOffer, isSLCOffer, isSLCPricingEnabled) {
    if (!(offer === null || offer === void 0 ? void 0 : offer.offer_id) || !pricingOffer) {
        return {
            installments: [],
            subscriptionFee: 0,
            monthlyRent: 0,
            processingFeePercentage: 0,
            offerState: '',
            creditLimit: 0,
            creditUtilization: 0
        };
    }
    var financeChargePercentage = (pricingOffer.finance_charge_percent || 0) * 100; // multiply by 100 to match processing fee percentage
    var processingFeePercentage = isSLCPricingEnabled
        ? financeChargePercentage
        : (0, pricing_offer_1.getProcessingFeePercentage)(paymentMethodType, pricingOffer);
    var monthlyRent = offer.estimated_bill_amount_cent || 0;
    var subscriptionFee = pricingOffer.membership_fee_amount || 0;
    var offerInstallments = offer.installments || [];
    var creditLimitCent = offer.credit_limit_amount_cent;
    var creditUtilizationCent = offer.credit_utilization_cent;
    var offerState = offer.offer_state || '';
    var propertyPassthroughFee = pricingOffer.property_passthrough_fee_amount || 0;
    var installments = offerInstallments && offerInstallments.length > 0
        ? (0, calculate_installments_1.calculateInstallments)(offerInstallments, monthlyRent, processingFeePercentage, propertyPassthroughFee, creditUtilizationCent, isSLCOffer)
        : [];
    return {
        paymentMethodType: paymentMethodType,
        installments: installments,
        subscriptionFee: subscriptionFee,
        monthlyRent: monthlyRent,
        processingFeePercentage: processingFeePercentage,
        offerState: offerState,
        creditLimit: creditLimitCent,
        creditUtilization: creditUtilizationCent,
        propertyPassthroughFee: propertyPassthroughFee
    };
};
exports.getOfferFees = getOfferFees;
